import { HeaderLeftBack } from './mobile/header-left-back';
import { HeaderLeftInvite } from './mobile/header-left-invite';
import { HeaderRightNotifications } from './mobile/header-right-notifications';

// React Navigation invokes header option callbacks as plain functions inside
// HeaderConfig. Return elements from dedicated render callbacks so hooks used
// by the header components are tracked on their own React fibers.
export function renderHeaderRightNotifications() {
  return <HeaderRightNotifications />;
}

export function renderHeaderLeftBack() {
  return <HeaderLeftBack />;
}

export function renderHeaderLeftInvite() {
  return <HeaderLeftInvite />;
}
